import api from "@/plugins/api";
export async function fetchOrganisations(params, signal) {
    const response = await api.get("/organisations", {
        params: {
            page: params?.page,
            per_page: params?.perPage,
            sortBy: mapSortField(params?.sortBy),
            sortOrder: params?.sortOrder,
            search: params?.search || undefined,
            // Only send when scoping to a contact — omitted means the global list (no filter).
            contactId: params?.contactId || undefined,
        },
        signal,
    });
    return response.data;
}
export async function searchOrganisations(params, signal) {
    const body = {
        filterId: params?.filterId ?? null,
        ast: params?.ast ?? undefined,
        page: params?.page,
        pageSize: params?.pageSize,
        sortBy: mapSortField(params?.sortBy),
        sortOrder: params?.sortOrder,
    };
    if (params?.refinement !== undefined) {
        body.refinement = params.refinement;
    }
    const response = await api.post('/portal/organisations/search', body, { signal });
    return response.data;
}
export async function fetchOrganisationAddresses(id, params) {
    const response = await api.get(`/organisations/${id}/addresses`, {
        params: {
            page: params?.page,
            per_page: params?.perPage,
        },
    });
    return response.data;
}
export async function fetchOrganisationById(id) {
    const response = await api.get(`/organisations/${id}`, { unwrapEnvelope: true });
    return response.data;
}
export async function createOrganisationAddress(id, request) {
    const response = await api.post(`/organisations/${id}/addresses`, request, { unwrapEnvelope: true });
    return response.data;
}
export async function updateOrganisationAddress(id, addressId, request) {
    await api.put(`/organisations/${id}/addresses/${addressId}`, request, { unwrapEnvelope: true });
}
export async function setPrimaryOrganisationAddress(id, addressId) {
    await api.put(`/organisations/${id}/addresses/${addressId}/primary`, undefined, {
        unwrapEnvelope: true,
    });
}
export async function deleteOrganisationAddress(id, addressId) {
    await api.delete(`/organisations/${id}/addresses/${addressId}`, { unwrapEnvelope: true });
}
export async function saveOrganisationLayout(id, request) {
    const response = await api.post(`/organisations/${id}/save`, request, {
        unwrapEnvelope: true,
    });
    const { updatedLayout, ...rest } = response.data;
    return {
        ...rest,
        id: updatedLayout?.id,
        layout: updatedLayout?.layout,
        properties: updatedLayout?.properties,
    };
}
export async function checkOrganisationDuplicates(params) {
    const response = await api.post("/organisations/check-duplicates", params, { unwrapEnvelope: true });
    return response.data;
}
export async function getOrganisationPreviewById(id) {
    const response = await api.get(`/organisations/${id}/preview`, {
        unwrapEnvelope: true,
    });
    return response.data;
}
export async function fetchLegalFormsLookup() {
    const response = await api.get("/organisations/lookups/legal-forms", {
        unwrapEnvelope: true,
    });
    return response.data;
}
export async function fetchActivityCodesLookup() {
    const response = await api.get("/organisations/lookups/activity-codes", { unwrapEnvelope: true });
    return response.data;
}
export async function checkOrganisationsExistByPrimaryRegistrationNumber(primaryRegistrationNumbers) {
    const response = await api.post("/organisations/check-primary-registration-number-exists", { primaryRegistrationNumbers }, { unwrapEnvelope: true });
    return response.data;
}
export async function createOrganisation(payload) {
    const response = await api.post("/organisations", payload, { unwrapEnvelope: true });
    return response.data;
}
export async function addOrganisationAddress(organisationId, payload) {
    await api.post(`/organisations/${organisationId}/addresses`, payload);
}
function mapSortField(field) {
    if (!field)
        return undefined;
    const map = {
        legalName: "legal_name",
        tradeName: "trade_name",
        organisationType: "organisation_type",
        createdAt: "created_at",
        updatedAt: "updated_at",
    };
    return map[field] ?? field;
}
/** Returns the new channel's ID (BFF returns ApiResponse<Guid>, interceptor unwraps to string). */
export async function createOrganisationCommunicationChannel(organisationId, payload) {
    const response = await api.post(`/organisations/${organisationId}/communication-channels`, payload, { unwrapEnvelope: true });
    return response.data;
}
export async function updateOrganisationCommunicationChannel(organisationId, channelId, payload) {
    await api.put(`/organisations/${organisationId}/communication-channels/${channelId}`, payload, { unwrapEnvelope: true });
}
export async function deleteOrganisationCommunicationChannel(organisationId, channelId) {
    await api.delete(`/organisations/${organisationId}/communication-channels/${channelId}`, { unwrapEnvelope: true });
}
export const organisationSocialProfileApi = {
    /** Returns the new profile's ID (BFF returns ApiResponse<Guid>, interceptor unwraps to string). */
    create(organisationId, data) {
        return api
            .post(`/organisations/${organisationId}/social-profiles`, { socialNetworkId: data.networkId, value: data.value, label: data.label }, { unwrapEnvelope: true })
            .then((r) => r.data);
    },
    update(organisationId, profileId, data) {
        return api.put(`/organisations/${organisationId}/social-profiles/${profileId}`, { socialNetworkId: data.networkId, value: data.value, label: data.label }, { unwrapEnvelope: true });
    },
    delete(organisationId, profileId) {
        return api.delete(`/organisations/${organisationId}/social-profiles/${profileId}`, { unwrapEnvelope: true });
    },
};
